var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("leo-input", {
        attrs: {
          type: "text",
          id: "username",
          label: _vm.userIdLabel,
          placeholder: _vm.placeholderMessage,
          error: _vm.isError,
          v2: "",
          errorIcon: "",
          disabled: _vm.isDisabled,
          maxLength: "50",
          autocomplete: _vm.autocomplete,
        },
        on: {
          keydown: _vm.onkeydown,
          blur: function ($event) {
            return _vm.$emit("onBlur")
          },
        },
        scopedSlots: _vm._u([
          {
            key: "error",
            fn: function () {
              return [
                _vm.usernameApiErrMsg
                  ? _c("span", [_vm._v(_vm._s(_vm.usernameApiErrMsg))])
                  : _c("span", [
                      _vm._v(
                        _vm._s(
                          !_vm.$v.username.required
                            ? _vm.requiredUsernameErrorMsg
                            : _vm.userInputErrMessage.validEmailAllowed
                        )
                      ),
                    ]),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.$v.username.$model,
          callback: function ($$v) {
            _vm.$set(
              _vm.$v.username,
              "$model",
              typeof $$v === "string" ? $$v.trim() : $$v
            )
          },
          expression: "$v.username.$model",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }